import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9.25 18.25h-3.5a2 2 0 0 1-2-2V3.75a2 2 0 0 1 2-2h5.5m0 0 5 5m-5-5v5h5m0 0v2.5m2 4.5L16 16m0 0-2.25 2.25M16 16l-2.25-2.25M16 16l2.25 2.25"
	})]
});
const ForwardRef = forwardRef(SvgFileClose);
export { ForwardRef as ReactComponent };
